/* src/app/location-users/add-location-users/new-user-queue/new-user-queue.component.scss */
.new-user-queue {
  margin-top: 20px;
  min-width: 880px;
}
.new-user-queue .queue-title-line {
  display: flex;
  justify-content: space-between;
}
.new-user-queue .queue-title-line h1 {
  font-size: 21px;
  align-self: flex-end;
}
.new-user-queue .queue-title-line .listed-entries-display {
  align-self: flex-end;
}
.new-user-queue .queue-title-line .listed-entries-display .attention-needed-entries {
  padding-right: 1rem;
  color: #C91913;
}
.new-user-queue .queue-title-line .listed-entries-display .attention-needed-entries::before {
  font-family: "upsicons", fantasy !important;
  content: "\e638" !important;
  padding-right: 0.25rem;
  font-size: 16px;
}
.user-queue-list {
  height: 390px;
  list-style: none;
  clear: both;
  padding: 0;
  overflow-y: auto;
  border: 1px solid #6E6E6E;
}
/*# sourceMappingURL=new-user-queue.component.css.map */
